module.exports = __webpack_public_path__ + "img/img4.aa7f5a15.jpg";